import { Provider } from "@redotech/redo-order-common/provider";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getIntegrationsByTeam = {
  name: "getIntegrationsByTeam" as const,
  input: z.object({}),
  output: z.array(createEnum(Provider)),
};
